<template>
    <div v-if="value" class="slider-verify">
        <div class="slider-verify__mask"></div>
        <section class="slider-verify__panel">
            <header class="slider-verify__header">
                <h2>滑动校验</h2>
                <button type="button" @click="close">关闭</button>
            </header>
            <p class="slider-verify__tips">请将左侧滑块拖进框内</p>

            <div class="slider-verify__image-wrap">
                <img class="slider-verify__image" :src="verifyImg" alt="" draggable="false" />
                <img
                    v-if="verifyBlock"
                    class="slider-verify__block"
                    :src="verifyBlock"
                    alt=""
                    draggable="false"
                    :style="blockStyle"
                />
            </div>

            <div ref="trackRef" class="slider-verify__track">
                <button
                    class="slider-verify__thumb"
                    type="button"
                    :style="thumbStyle"
                    @mousedown="startDrag"
                    @touchstart.passive="startDrag"
                ></button>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'SliderVerify',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        verifyImg: {
            type: String,
            default: ''
        },
        verifyBlock: {
            type: String,
            default: ''
        },
        blockY: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            startPageX: 0,
            moveLeft: 0,
            maxLeft: 240,
            dragging: false
        }
    },
    computed: {
        blockStyle() {
            return {
                top: `${this.blockY || 0}px`,
                left: `${this.moveLeft}px`
            }
        },
        thumbStyle() {
            return {
                left: `${this.moveLeft}px`
            }
        }
    },
    watch: {
        value(value) {
            if (value) this.reset()
        },
        verifyImg() {
            this.reset()
        },
        verifyBlock() {
            this.reset()
        }
    },
    beforeDestroy() {
        this.removeDragListeners()
    },
    methods: {
        getPageX(event) {
            return (
                (event.touches && event.touches[0] && event.touches[0].pageX) ||
                (event.changedTouches && event.changedTouches[0] && event.changedTouches[0].pageX) ||
                event.pageX
            )
        },
        updateMaxLeft() {
            const trackWidth = (this.$refs.trackRef && this.$refs.trackRef.offsetWidth) || 280
            this.maxLeft = Math.max(trackWidth - 40, 0)
        },
        reset() {
            this.moveLeft = 0
            this.dragging = false
        },
        close() {
            this.reset()
            this.$emit('input', false)
            this.$emit('close')
        },
        moveDrag(event) {
            if (!this.dragging) return
            const nextLeft = this.getPageX(event) - this.startPageX
            this.moveLeft = Math.min(Math.max(nextLeft, 0), this.maxLeft)
        },
        endDrag() {
            if (!this.dragging) return
            this.dragging = false
            this.removeDragListeners()
            this.$emit('check', Math.round(this.moveLeft))
        },
        startDrag(event) {
            this.updateMaxLeft()
            this.dragging = true
            this.startPageX = this.getPageX(event) - this.moveLeft
            window.addEventListener('mousemove', this.moveDrag)
            window.addEventListener('mouseup', this.endDrag)
            window.addEventListener('touchmove', this.moveDrag, { passive: true })
            window.addEventListener('touchend', this.endDrag)
        },
        removeDragListeners() {
            window.removeEventListener('mousemove', this.moveDrag)
            window.removeEventListener('mouseup', this.endDrag)
            window.removeEventListener('touchmove', this.moveDrag)
            window.removeEventListener('touchend', this.endDrag)
        }
    }
}
</script>

<style scoped>
.slider-verify {
    position: fixed;
    inset: 0;
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.slider-verify__mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
}

.slider-verify__panel {
    position: relative;
    width: auto;
    border-radius: 12px;
    background: #ffffff;
    padding: 18px;
}

.slider-verify__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.slider-verify__header h2 {
    margin: 0;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
}

.slider-verify__header button {
    border: 0;
    background: transparent;
    color: #333333;
    font-size: 14px;
}

.slider-verify__tips {
    margin: 6px 0 8px;
    color: #999999;
    font-size: 14px;
    line-height: 20px;
}

.slider-verify__image-wrap {
    position: relative;
    width: 280px;
    height: 170px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 4px;
}

.slider-verify__image {
    display: block;
    width: 280px;
    height: 170px;
    object-fit: fill;
    user-select: none;
}

.slider-verify__block {
    position: absolute;
    width: 60px;
    height: 60px;
    user-select: none;
}

.slider-verify__track {
    position: relative;
    width: 280px;
    height: 40px;
    margin: 18px auto 0;
    overflow: hidden;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.07);
}

.slider-verify__thumb {
    position: absolute;
    top: 0;
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 999px;
    background: #26cf98;
    cursor: grab;
}

.slider-verify__thumb:active {
    cursor: grabbing;
}
</style>

